import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigator } from "../services/navigation";

export default function NavigatorBinder() {
    const navigate = useNavigate();

    useEffect(() => {
        setNavigator(navigate);
    }, [navigate]);

    return null;
}